import axios from 'axios';
import { getCookie, deleteCookie } from '../utils/helpers';
import { refreshToken, isTokenRefreshInProgress } from './auth';

const api = axios.create({
  timeout: 20000,
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const url = (config.url || '').toString();
    const isPublicAuthEndpoint =
      url.includes('/auth/login') ||
      url.includes('/auth/signup') ||
      url.includes('/auth/google/login') ||
      url.includes('/auth/verify-otp') ||
      url.includes('/auth/resend-otp-email') ||
      url.includes('/auth/forgot-password') ||
      url.includes('/auth/verify-reset-token') ||
      url.includes('/auth/reset-password') ||
      url.includes('/token/refresh') ||
      url.includes('/kit-assignment');

    if (!isPublicAuthEndpoint) {
      const token = getCookie('access');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const originalRequest = error.config;
    const isPublicAuthEndpoint =
      url.includes('/auth/login') ||
      url.includes('/auth/signup') ||
      url.includes('/auth/google/login') ||
      url.includes('/auth/verify-otp') ||
      url.includes('/auth/resend-otp-email') ||
      url.includes('/auth/forgot-password') ||
      url.includes('/auth/verify-reset-token') ||
      url.includes('/auth/reset-password') ||
      url.includes('/token/refresh') ||
      url.includes('/kit-assignment');

    if (status === 401 && !isPublicAuthEndpoint) {
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        const attempt = () =>
          refreshToken()
            .then(({ access }) => {
              if (access) {
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers.Authorization = `Bearer ${access}`;
              }
              return api(originalRequest);
            })
            .catch(() => {
              deleteCookie('access');
              deleteCookie('refresh');
              window.location.href = '/signin';
              return Promise.reject(error);
            });
        if (isTokenRefreshInProgress()) {
          return new Promise((resolve) => setTimeout(resolve, 200)).then(() =>
            attempt()
          );
        }
        return attempt();
      } else {
        deleteCookie('access');
        deleteCookie('refresh');
        window.location.href = '/signin';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
